import React from "react";
import styled from "styled-components";

import FadlElziker from "./FadlElzikr/FadlElziker";
import FavouriteAzkar from "./FavouriteAzkar/FavouriteAzkar";
import AllAzkar from "./AllAzkar/AllAzkar";
import Awrad from "./Awrad/Awrad";
import homePageData from "./HomePageData";
import Navbar from "../../Navbar/Navbar";
import { Container } from "../../Container/Container";

const Header = styled.div`
  padding: 0 20px;
`;

const Title = styled.h1`
  font-size: 16px;
  font-weight: normal;
  padding-bottom: 5px;
`;
const SubTitle = styled.h2`
  font-size: 18px;
  margin-bottom: 25px;
  font-weight: 400;
`;

function HomePage({ isOpen, toggle }) {
  return (
    <>
      <Navbar brand={homePageData.brand} isOpen={isOpen} toggle={toggle} />
      <Container>
        <Header>
          <Title>{homePageData.title}</Title>
          <SubTitle>{homePageData.subTitle}</SubTitle>
        </Header>
        <FadlElziker />
        <FavouriteAzkar />
        <AllAzkar />
        <Awrad />
      </Container>
    </>
  );
}

export default HomePage;
